module.exports = __webpack_public_path__ + "static/media/signup-image-4.e6b8ddfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/signup-image-4.jpg
// module id = 958
// module chunks = 0